import React from "react"
import { ButtonBase, ButtonProps } from "./ButtonBase"

export const ButtonAction = ({ className, ...props }: ButtonProps) => {
  return (
    <ButtonBase
      className={`shadow-actionButton text-textSecondary1 bg-ctaSecondaryOne hover:bg-ctaSecondaryTwo active:bg-ctaSecondaryThree border-l-[0.5px] border-r-[0.5px] border-t-[1px] border-white/25 disabled:shadow-buttonNuetral disabled:bg-whiteHover ${className}`}
      {...props}
    />
  )
}
